module.exports = __webpack_public_path__ + "img/sol.360551ea.svg";